<template>
  <div class="skin-card-container">
    <div
      class="skin-card relative"
    >
      <img
        :src="champion.image_url"
        class="absolute w-full h-full"
        :alt="champion.name + ' Skins'"
      />
      <div class="skin-card__overview">
        <div class="flex flex-col text-center bg-metallic-grey-60 p-2 pt-5 relative">
          <div class="absolute self-center top-0 -mt-3 w-2/3 text-xs leading-sm bg-royal-purple rounded border border-smog-grey">
            Champion
          </div>
          <div
            class="text-center font-bold text-absolute-white"
            v-html="champion._highlightResult.name.value + ' Skins'"
          ></div>
          <div class="text-xs flex items-center justify-center">
            <span>{{ formattedSkinsCount }}</span>
          </div>
        </div>
      </div>
      <div class="skin-card__details bg-metallic-grey-60 relative">
        <div class="absolute inset-x-0 top-0 text-xs text-slightly-off-white text-center">
          {{ champion.name }} Skins
        </div>
        <a :href="champion.url" class="simple-btn btn-white btn-ghost text-sm font-bold">View Skins</a>
        <div class="absolute inset-x-0 bottom-0 text-xs text-slightly-off-white text-center">
          {{ formattedSkinsCount }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    champion: Object,
  },

  computed: {
    formattedSkinsCount() {
      const count = this.champion.skins_count;
      return count > 1 ? `${count} Skins` : `${count} Skin`;
    },
  },
};
</script>

<style lang="scss" scoped>
.skin-card img {
  object-fit: cover;
  object-position: 75% 0;
}
</style>
